// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2whSA","right":"Footer_right__3yDC3","buttons":"Footer_buttons__2eHt1"};